import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { withEnvGuard } from '@traton/devportal-env-kit-app';
import { rootRouteRef } from './routes';
import { portalgroupsApiRef } from './api/PortalgroupsApi';
import { PortalgroupsClient } from './api/PortalgroupsClient';

export const portalgroupsPlugin = createPlugin({
  id: 'portalgroups',
  apis: [
    createApiFactory({
      api: portalgroupsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new PortalgroupsClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const PortalgroupsPage = portalgroupsPlugin.provide(
  createRoutableExtension({
    name: 'PortalgroupsPage',
    component: () =>
      import('./components/ui/Layout').then(m =>
        withEnvGuard(m.Layout, 'portalgroups'),
      ),
    mountPoint: rootRouteRef,
  }),
);
